import React from 'react';
import Panel from '@atlaskit/panel';
import Page from '@atlaskit/page';

interface Props {
  header?: string;
}
function AuditTrailPanel({ children, header = '' }: React.PropsWithChildren<Props>) {
  return (
    <Page>
      <Panel header={header}>{children}</Panel>
    </Page>
  );
}

export default AuditTrailPanel;
